import React from "react";
import { Row, Col } from "reactstrap";
import DesignCard from "../DesignCard";
import get from "lodash/get";

const _ = { get };

const EventsReportsDetailPage = ({ rowData, elements }) => {
  return (
    <React.Fragment>
      {rowData ? (
        <div className="hideSearch my-3 px-3">
          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.eventNameElement",
                  "Event Name"
                )}
                titleName={rowData.eventName}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.eventCountryElement",
                  "Event Country"
                )}
                titleName={rowData.eventCountry}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.eventStateElement",
                  "Event State"
                )}
                titleName={rowData.eventState}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.eventCityElement",
                  "Event City"
                )}
                titleName={rowData.eventCity}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.eventCityElement",
                  "Event City"
                )}
                titleName={rowData.eventLocation}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.branchNameElement",
                  "Branch Name"
                )}
                titleName={rowData.branchName}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.branchCodeElement",
                  "Branch Code"
                )}
                titleName={rowData.branchCode}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.eventStartDateElement",
                  "Ride Start Date"
                )}
                titleName={rowData.eventStartDate}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.eventEndDateElement",
                  "Ride End Date"
                )}
                titleName={rowData.eventEndDate}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.eventStatusElement",
                  "Event Status"
                )}
                titleName={rowData.eventStatus}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.moderationStatusElement",
                  "Moderation Status"
                )}
                titleName={rowData.moderationStatus}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.allocatedRideCountElement",
                  "Allocated Ride Count"
                )}
                titleName={rowData.allocatedRiderCount}
              />
            </Col>
            <Col xl={8} lg={8} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "eventsReportsDetailElement.eventDescriptionElement",
                  "Event Description"
                )}
                titleName={rowData.eventDescription}
              />
            </Col>
          </Row>
        </div>
      ) : (
        <h5 className="text-center font-weight-bold">
          {_.get(
            elements,
            "eventsReportsDetailElement.noUserFoundElement",
            "No user found"
          )}
        </h5>
      )}
    </React.Fragment>
  );
};

export default EventsReportsDetailPage;
